// extracted by mini-css-extract-plugin
module.exports = {"vanlife-roadtrips-G1":"G1_vanlife-roadtrips-G1__N740k"};